import { render, staticRenderFns } from "./IssueDetails.vue?vue&type=template&id=32e4eccc&scoped=true&"
import script from "./IssueDetails.vue?vue&type=script&lang=js&"
export * from "./IssueDetails.vue?vue&type=script&lang=js&"
import style0 from "./IssueDetails.vue?vue&type=style&index=0&id=32e4eccc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4eccc",
  null
  
)

export default component.exports